import Compute from './compute'

// 定义资源数据源
export const POLICY_RES_LIST = [
  Compute,
]
